<template>
  <div id="mypage-education-calendar-template">
    <div id="education-calendar-app" class="mt-40"></div>
    <div class="table-wrap scroll-table mt-40" v-if="showDetail">
      <table class="table-list">
        <caption>공고목록</caption>
        <colgroup>
          <col style="width:200px">
          <col style="width:80px">
          <col style="width:300px">
          <col style="width:80px">
          <col style="width:80px">
          <col style="width:80px">
        </colgroup>
        <thead>
          <tr>
            <th scope="col">중분류</th>
            <th scope="col">소분류</th>
            <th scope="col">강좌명</th>
            <th scope="col">강사</th>
            <th scope="col">상태</th>
            <th scope="col"><span class="sr-only">출석여부</span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-c">{{term}}</td>
            <td class="text-c">{{faculty}}</td>
            <td class="text-c">{{title}}</td>
            <td class="text-c">{{mainLecturer}}</td>
            <td class="text-c">{{progress}}</td>
            <td class="text-c"><button type="button" class="btn btn-gray btn-xsm" @click="showAttendanceModal(courseId)">출석확인</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <attendance-modal :showModal="showModal" :courseId="courseId" @close="closeModal"></attendance-modal>
  </div>
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';
  import AttendanceModal from './AttendanceModal.vue';

  const MonChange = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };

  export default {
    name: 'mypage-education-calendar-template',
    components: {
      AttendanceModal,
    },
    props: [''],
    data() {
      return {
        calendar: null,
        MonChange,
        yearMonth: '',
        showModal: false,
        showDetail: false,

        getIds: [],
        getMonth: [],
        course: {},
        courseId: '',
        lectureId: '',
        title: '',
        mainLecturer: '',
        progress: '',
        calendarId: '',
        term: '',
        faculty: '',

        getEvents: [],
      };
    },
    methods: {
      closeModal() {
        this.showModal = false;
        $('body').removeClass('modal-open');
      },
      showAttendanceModal(courseId) {
        this.showModal = true;
        this.courseId = courseId;
        $('body').addClass('modal-open');
      },
      drawCalendar() {
        // Vue의 nextTick을 사용해서 DOM이 완전히 렌더링된 후 실행
        this.$nextTick(() => {
          const calendarEl = document.getElementById('education-calendar-app');
          if (!calendarEl) {
            console.error('Calendar element not found');
            return;
          }

          // FullCalendar가 로드되었는지 확인
          if (!window.FullCalendar) {
            console.error('FullCalendar not loaded');
            return;
          }

          this.calendar = new window.FullCalendar.Calendar(calendarEl, {
            locale: 'ko',
            initialView: 'dayGridMonth',
            headerToolbar: {
              left: 'dayGridMonth,timeGridWeek',
              center: 'title',
              right: 'prev,today,next',
            },
            slotMinTime: '09:00:00',
            slotMaxTime: '22:00:00',
            allDaySlot: true,
            editable: true,
            timeZone: 'Asia/Seoul',
            navLinks: false, // 날짜 클릭 시 일별 보기 이동 비활성화
            slotEventOverlap: false,
            events: this.getEvents,

            // 날짜 클릭 이벤트 비활성화
            dateClick: (info) => {
              // 날짜 클릭 시 아무 동작하지 않음
              info.jsEvent.preventDefault();
            },

            datesSet: (dateInfo) => {
              console.log('날짜 범위 변경:', dateInfo);
              this.handleDateRangeChange(dateInfo);
              // 캘린더 렌더링 후 mt-40 클래스 유지
              this.ensureMt40Class();
            },

            eventClick: (info) => {
              this.calendarId = info.event.id;
              this.courseId = info.event.extendedProps.courseId;
              this.lectureId = info.event.extendedProps.lectureId;
              this.title = info.event.title;
              this.mainLecturer = info.event.extendedProps.mainLecturer;
              this.progress = info.event.extendedProps.progress;
              this.faculty = info.event.extendedProps.faculty;
              this.term = info.event.extendedProps.term;
              this.showDetail = true;
            },

          });

          this.calendar.render();

          // 초기 렌더링 후 mt-40 클래스 확실히 추가
          this.ensureMt40Class();
        });
      },
      // 새로 받아온 원본 이벤트만 변환/중복제거해서 FullCalendar 포맷으로 반환한다.
      // (이미 그려진 이벤트까지 매번 다시 훑지 않도록 증분으로만 처리)
      eventSetting(rawEvents) {
        const newFormattedEvents = [];

        rawEvents.forEach((val) => {
          if (this.getIds.indexOf(val.id) !== -1) return;

          const date = val.date.toString();
          const startTiemString = val.startTime.toString();
          const endTiemString = val.endTime.toString();

          const year = date.slice(0, 2);
          const month = date.slice(2, 4);
          const day = date.slice(4);

          const sTime = `${startTiemString.slice(0, 2)}:${startTiemString.slice(2, 4)}`;
          const eTime = `${endTiemString.slice(0, 2)}:${endTiemString.slice(2, 4)}`;

          const startFormat = `20${year}-${month}-${day} ${sTime}`;
          const endFormat = `20${year}-${month}-${day} ${eTime}`;

          const formattedEvent = {
            id: val.id,
            title: val.title,
            start: startFormat,
            end: endFormat,
            extendedProps: {
              courseId: val.courseId,
              lectureId: val.lectureId,
              faculty: val.faculty,
              mainLecturer: val.mainLecturer,
              term: val.term,
              org: val.org,
              date: val.date,
              startTime: val.startTime,
              endTime: val.endTime,
              progress: val.progress,
            },
          };

          this.getEvents.push(formattedEvent);
          this.getIds.push(val.id);
          newFormattedEvents.push(formattedEvent);
        });

        return newFormattedEvents;
      },
      handleDateRangeChange(dateInfo) {
        // 현재 표시되는 월 추출 (dateInfo.start는 그리드를 채우기 위한 앞뒤 월 패딩이 포함될 수 있으므로,
        // 로드 여부 판단에는 패딩이 없는 실제 뷰의 월(view.currentStart)을 사용한다)
        const currentDate = dateInfo.view.currentStart;
        const year = currentDate.getFullYear().toString().slice(-2); // 25
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 07
        const currentMonth = `${year}${month}`; // 2507

        // 이미 로드된 월인지 확인
        if (this.getMonth.indexOf(currentMonth) === -1) {
          // 새로운 월 데이터 로드 (그리드에 보이는 패딩 범위까지 포함해서 조회)
          const startDate = this.formatDate(dateInfo.start);
          const endDate = this.formatDate(dateInfo.end);

          this.getEventData(startDate, endDate);
          this.getMonth.push(currentMonth);
        }
      },

      formatDate(date) {
        // Date 객체를 YYYYMMDD 형식으로 변환
        const year = date.getFullYear().toString().slice(-2);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
      },

      async getEventData(startDate, endDate) {
        try {
          const response = await axios.get(`/api/courses/schedules?startDate=${startDate}&endDate=${endDate}`);
          const newEvents = response.data || [];

          // 새로 받아온 이벤트만 변환해서 캘린더에 증분 추가 (전체 재빌드 없음)
          const formattedNewEvents = this.eventSetting(newEvents);

          if (this.calendar && formattedNewEvents.length > 0) {
            this.calendar.addEventSource(formattedNewEvents);
          }
        } catch (error) {
          console.error('Failed to load events:', error);
        }
      },

      // FullCalendar 렌더링 후 mt-40 클래스 유지하는 메서드
      ensureMt40Class() {
        this.$nextTick(() => {
          const calendarEl = document.getElementById('education-calendar-app');
          if (calendarEl && !calendarEl.classList.contains('mt-40')) {
            calendarEl.classList.add('mt-40');
            console.log('mt-40 클래스 복원됨');
          }
        });
      },
    },
    mounted() {
      /* eslint no-underscore-dangle: ["error", { "allow": ["_d"] }] */
      const thisDay = String(moment().locale('ko')._d);
      const startDay = moment().startOf('month').locale('ko')._d;
      const endDay = moment().endOf('month').locale('ko')._d;
      const startFullDay = String(moment(startDay).startOf('week').locale('ko')._d);
      const endFullDay = String(moment(endDay).endOf('week').locale('ko')._d);
      const thisY = thisDay.slice(13, 15);
      const thisM = thisDay.slice(4, 7);
      const startY = startFullDay.slice(13, 15);
      const startM = startFullDay.slice(4, 7);
      const startD = startFullDay.slice(8, 10);
      const endY = endFullDay.slice(13, 15);
      const endM = endFullDay.slice(4, 7);
      const endD = endFullDay.slice(8, 10);
      this.getMonth.push(`${thisY}${MonChange[thisM]}`);

      const startDayOfWeek = `${startY}${MonChange[startM]}${startD}`;
      const endDayOfWeek = `${endY}${MonChange[endM]}${endD}`;
      this.getEventData(startDayOfWeek, endDayOfWeek);
      this.drawCalendar();
    },
  };
</script>

<style lang="scss">
  /* 사용자 정의 클래스에 white-space: normal; 적용 */
  .fc-daygrid-dot-event .fc-event-title {
    white-space: normal;
  }
</style>



// WEBPACK FOOTER //
// MypageEducationCalendar.vue?0daeacf7